import { useMemo } from 'react'
import { Combobox } from '@/components/Combobox'
import { FlagIcon } from '@/components/FlagIcon'
import { COUNTRY_LOCALE_MAP, COUNTRY_NAMES } from '@/lib/locale'

export type CountryComboboxProps = {
  value: string | null
  onChange: (code: string | null) => void
  /** Called with the matching currency when the user picks a country. */
  onCurrencyChange?: (currency: string) => void
  placeholder?: string
}

export function CountryCombobox({ value, onChange, onCurrencyChange, placeholder = 'Country' }: CountryComboboxProps) {
  const options = useMemo(() =>
    Object.entries(COUNTRY_NAMES)
      .map(([code, name]) => ({
        value: code,
        label: name,
        description: `${code} · ${COUNTRY_LOCALE_MAP[code as keyof typeof COUNTRY_LOCALE_MAP]?.currency ?? ''}`,
        icon: <FlagIcon code={code} />,
      }))
      .sort((a, b) => a.label.localeCompare(b.label)),
    [],
  )

  return (
    <Combobox<string>
      value={value}
      onChange={v => {
        const code = v ? String(v) : null
        onChange(code)
        if (code && onCurrencyChange) {
          const entry = COUNTRY_LOCALE_MAP[code as keyof typeof COUNTRY_LOCALE_MAP]
          if (entry?.currency) onCurrencyChange(entry.currency)
        }
      }}
      options={options}
      placeholder={placeholder}
      emptyMessage="No countries matched."
    />
  )
}
